import { CaseJson } from './case.js';

class NewController {
  /* @ngInject */
  constructor(
      $http, $state, $timeout, Session, TemplateSaveService,
      ENABLE_TA_DATE_CLIENT_IDS, CASE_JOINING_STATUSES
    ) {
    this.$http = $http;
    this.$state = $state;
    this.$timeout = $timeout;
    this.Session = Session;
    this.TemplateSaveService = TemplateSaveService;
    this.ENABLE_TA_DATE_CLIENT_IDS = ENABLE_TA_DATE_CLIENT_IDS;
    this.CASE_JOINING_STATUSES = CASE_JOINING_STATUSES;

    this.datepickerOptionsDOJ = {
      dateDisabled: ({ date, mode }) =>
        (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6)),
    };
  }

  populateFlags() {
    if (this.data.customerUser
      && this.ENABLE_TA_DATE_CLIENT_IDS.includes(this.data.customerUser.Client.id)
    ) {
      this.data.config.enableTADate = true;
      this.data.config.enableJoiningData = true;
      this.data.joiningStatus = 'Yet to Join';
    } else {
      this.data.config.enableTADate = false;
      this.data.config.enableJoiningData = false;
      this.data.joiningStatus = undefined;
    }
  }

  $onInit() {
    this.user = this.Session.read('userinfo') || {};
    this.isBetaUser = (this.Session.read('debug') || {}).userType === 'beta';
    this.data = angular.copy(CaseJson);

    if (this.ENABLE_TA_DATE_CLIENT_IDS.includes(this.user.client.id)) {
      this.data.config.enableTADate = true;
      this.data.config.enableJoiningData = true;
      this.data.joiningStatus = 'Yet to Join';
    }
    this.getCategories();
    this.isVendor = this.user.client.type === 'VENDOR';

    if (this.isVendor) this.getClientUsers();
  }

  getClientUsers() {
    this.$http.get('/clientVendor/clientUsers')
      .then(({ data = [] }) => (this.clientUsers = data));
  }

  getCategories() {
    this.$http.get('/clientCategory', {
      params: {
        customerClientId: this.data.customerUser && this.data.customerUser.Client.id,
      },
    })
      .then(({ data = [] }) => (this.categories = data));

    this.populateFlags();
  }

  changeCategory() {
    const category = this.categories.find(v => (v.id === this.data.categoryId));
    this.standardCheck = !!category;
    this.$timeout(() => {
      this.data = {
        categoryId: this.data.categoryId,
        customerUser: this.data.customerUser,
        config: (category || angular.copy(CaseJson)).config,
      };

      this.data.config.customFields = this.data.config.customFields || {
        value: [],
      };
      if (this.data.config.enableJoiningData) {
        this.data.joiningStatus = 'Yet to Join';
      } else {
        this.data.joiningStatus = undefined;
      }
    }, 100);
  }

  submit(form) {
    if (form.$invalid || this.submitting) return;

    this.submitting = true;
    this.showSpinner = true;
    this.$http.post('/case', this.data)
      .then(({ data }) => {
        this.submitting = false;
        this.$state.go('main.cases.vendor', { id: data.id });
      })
      .catch(() => {
        this.submitting = false;
        this.showSpinner = false;
      });
  }

  isCaseSelected() {
    this.showMessage = '';
    const isSelected = Object.keys(this.data.config).some(i => this.data.config[i].selected);

    if (!isSelected) {
      this.showMessage = 'You are not selected any verification checks';
      return false;
    }

    return true;
  }

  addCustomField() {
    this.singleField = {
      name: '',
    };

    this.data.config.customFields.value.push(this.singleField);
  }

  deleteCustomField(idx) {
    this.data.config.customFields.value.splice(idx, 1);
  }
}

export default NewController;



// WEBPACK FOOTER //
// ./client/app/cases/new/new.controller.js